<template>
  <div class="col-sm-12">
    <br />
    <div>
      <div>
        <div>
          <span>
            <p class="note">
              The file you upload must be an MS Acces or Excel file and it <strong>MUST</strong> be based on the blank template files. If you
              are starting out new, simply download the blank template files and start adding data. If you are planning on doing a batch update, Use
              the <a class="text" href="/admin-points-faq/create">Build User file</a> tool to create an Excel or Access file based on the template,
              make your changes, then upload them. It's as simple as that.
            </p>

            <fieldset>
              <legend>Download Blank Templates&nbsp;&nbsp;</legend>
              <div>
                <div>
                  <div>
                    <span>Blank Access Database template</span>
                    <span>[&nbsp;<a class="text" href="#">download</a>&nbsp;]</span>
                  </div>
                  <div>
                    <span>Blank Excel Template</span>
                    <span>[&nbsp;<a class="text" href="/admin/PointBatchTemplate.xls">download</a>&nbsp;]</span>
                  </div>
                </div>
              </div>
            </fieldset>
            <br />
          </span>
        </div>
      </div>
    </div>

    <br />
    <br />
    <h3>Blank templates</h3>
    <div>
      <div>
        <div>
          <span>
            <br />
            <h5>Access Database Template</h5>
          </span>
        </div>
        <div>
          <span>
            <p class="NOTE">
              If you plan on doing a lot of data entry, the access Database template is the easiest to use. Download the template and select the
              "forms" button on the left hand side. You should see a form called "users" listed:
            </p>
            <p class="NOTE">
              Open the form by double clicking on it. You should see a simple data entry form. Fill out each item and use the "TAB" key to move from
              one item to the next. Remember, Username, password, firstname and last name are all required - and you must have either a location name
              or location ID to be successful. See help on
              <a class="text" href="/admin-points-faq/co-matrix">locations</a> for more information.<br />
              <br />
              If you wish to add a new record to a group of existing records, simply click the asterick at the very bottom. Note: if you have yet to
              add a user, or if you already have a blank form in front of you, this button will be greyed out.
            </p>

            <p class="note">
              You can also add new users in "spreadsheet" view. Click on the "Tables" button (on the left) and then double click on users. You will
              see a spread sheet with all of the column headers.
            </p>
            <p class="note">Fill out each row as a single record.</p>
            <p class="note">
              If you are working with an access database and the file seems to be larger than you expected, you might try
              <a class="text" href="/admin-points-faq/access-compact">Compacting</a> it using the Access program.
            </p>
          </span>
        </div>
        <div>
          <span>
            <br />
            <h5>Excel Template use</h5>
          </span>
        </div>
        <div>
          <span>
            <p class="NOTE">
              The excel template is a lot like the access "datasheet" view. Simply open the file and begin typing in data. Warning: Because access is
              a spreadsheet program and <em>not</em> a database program, you can type letters in places where numbers aught to be. Be very careful to
              follow the <a class="text" href="/admin-points-faq/column">column guidlines</a> to ensure a successful upload. If you are using Excel
              5.0, Excel 2000, or Excel XP, you will see little red triangles in the corner of many of the column headers. Hovering over the triangle
              brings up a helpful note on how to use the column.
            </p>
          </span>
        </div>
      </div>
    </div>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: 'BlankTemplate',
};
</script>
<style lang="scss" scoped>
div {
  border: 0px solid transparent;
  font-size: 14px;
  width: inherit;
}
fieldset {
  padding: 0.35em 0.625em 0.75em;
  margin: 0 5px;
  border: 1px solid silver;
  border-radius: 8px;
  span {
    width: 210px;
    margin-bottom: 1%;
    display: inline-block;
  }
}
legend {
  width: auto;
  padding: 10px;
  font-size: 15px;
  color: #333;
  border: 0;
  border-bottom: none;
}
</style>
